import _ from 'lodash';

module.exports = function(angular,config){
    return function ($scope,$state,engine,gamelog,data) {
        engine.init();
        gamelog.reset();
        $scope.texts = data.texts;
        $scope.image = data.images.intro;


    }; 

};